import { graphql } from 'gatsby';
import React from 'react';
import { css } from '@emotion/react';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import { colors } from '../../primitives/colors';
import RichText from '../../primitives/rich-text';
import paddingDefault from '../../utils/padding-default';
import Container from '../../primitives/grid/container';
import { breakpoints } from '../../primitives/tokens';

const styles = {
    containerWrap: css({
        backgroundColor: colors.grey100,
    }),
    title: css({
        marginBottom: '24px',
        fontSize: '36px',
        lineHeight: 1.25,
        [breakpoints.mb]: {
            marginBottom: '16px',
        },
    }),
    copyWrap: css({
        fontSize: '20px',
        lineHeight: '28px',
        [breakpoints.mb]: {
            fontSize: '18px',
        },
    }),
    franchiseRichTextEditorStyles: css({
        p: { marginBottom: '20px' },
        'strong, h1, h2, h3, h4, h5': { fontWeight: 'bold', margin: '32px 0 8px' },
        i: { fontStyle: 'italic' },
        padding: '0',
        margin: '0',
        whiteSpace: 'pre-line',
    }),
};

const FranchiseCollapsibleAbout: React.FC<Queries.FranchiseCollapsibleAboutDataFragment> = ({ title }) => {
    const microsite = useMicrosite();
    const copy = (microsite?.franchise?.profileExcerpt || '');

    if (!copy) {
        return null;
    }

    return (
        <div css={[paddingDefault(), styles.containerWrap]}>
            <Container>
                <div>
                    <h2 css={styles.title}>{title}</h2>
                    <RichText maxLength={4} css={[styles.franchiseRichTextEditorStyles, styles.copyWrap]}>
                        {copy}
                    </RichText>
                </div>
            </Container>
        </div>
    );
};

export const query = graphql`
  fragment FranchiseCollapsibleAboutData on CsFranchiseCollapsibleAboutGroup {
    title
  }
`;

export default FranchiseCollapsibleAbout;
